// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ame23","label":"styles_label__1CUO3"};